import { supabase } from '../../supabase'
import EdgeFunctionService, { EdgeFunctionResult } from '../domain/EdgeFunctionService'

export default class SupabaseEdgeFunctionService implements EdgeFunctionService {
  async invoke<T>(name: string, body?: Record<string, unknown>): Promise<EdgeFunctionResult<T>> {
    const { data, error } = await supabase.functions.invoke(name, { body })
    return {
      data: (data as T) ?? null,
      error: error ? new Error(error.message) : null,
    }
  }
}
